import React from "react";

function ArrowRightIcon3() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 9 16"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1.5 1.25L8.25 8 1.5 14.75"
      ></path>
    </svg>
  );
}

export default ArrowRightIcon3;
